<template>
    <div>
        <v-card v-for="item in cartItems" :key="item.id" class="px-2 py-3 my-3">
            <v-row wrap>
                <v-col cols="2">
                    <v-img :src="image"></v-img>
                </v-col>
                <v-col cols="7">
                    <h3>Prenda {{ item.id }} </h3>
                    <p>{{ item.idea }}</p>
                    <p>Colores:</p>
                    <v-row wrap>
                    <div class="selectionColors" :style="{backgroundColor: i}"   v-for="i in item.colores" :key="i"></div>
                     </v-row>

                </v-col>
                <v-col cols="2">
                   <h3>{{ item.precio }} €</h3> 

                </v-col>
                <v-col cols="1">
                    <v-icon color="red" @click="fDeleteItem(item)">mdi-delete</v-icon>
                </v-col>
            </v-row>
        </v-card>

        <h3>
            TOTAL: {{ cTotal }} € + IVA
        </h3>
    </div>
</template>
<script>


import Image from '../assets/3.jpg'

export default {
    data: () => ({
    image: Image,
    cartItems: []
  }),

  methods:{
    fDeleteItem(item){
        this.cartItems.splice(this.cartItems.indexOf(item),1)
        window.localStorage.setItem('cart', JSON.stringify(this.cartItems))
    }
  },    
  mounted(){
    let cart = window.localStorage.getItem('cart')
    if(cart !=null){
        this.cartItems = JSON.parse(cart)
    }
  },
  computed:{
    cTotal(){
        let total = 0
        this.cartItems.forEach(i =>{
            if(i != null){
                total += i.precio
            }
        })
        return total
    }
  }
}

</script>


<style>
    .selectionColors{
        width: 20px;
        height: 20px;
        border-radius: 100%;
        margin: 5px;
    }
</style>